/**
 * @file  header/content.ts
 * @description  handles the json content to interface mapping
 *
 * @author ogarcia (ozkary)
 *
 */
import { HeaderModel } from './header.model';

// load the header information per brand and edition comobination
// e.i  meineke: ppm, vsc
const resources = (async (): Promise<HeaderModel> => await import('../../content/header.json'))();

// export the promise. The component must await the resuults
export const ContentLoader = resources;
